import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/page.js");
